import React, { useState } from 'react'

const FAQ = () => {
    const [openIndex, setOpenIndex] = useState(null)
    const [showFAQs, setShowFAQs] = useState(false)

    const faqs = [
        {
            question: "What services do you offer?",
            answer: "We specialize in web development (WordPress, React, custom websites), private cloud setup and maintenance (Nextcloud, collaboration tools), digital marketing (social media, content strategy, ad campaigns), and comprehensive SEO optimization."
        },
        {
            question: "How much does a website cost?",
            answer: "Website pricing varies based on complexity and requirements. A basic WordPress site starts from R8,500, while custom web applications range from R25,000+. Contact us for a detailed quote tailored to your specific needs."
        },
        {
            question: "How long does it take to build a website?",
            answer: "Timelines depend on project scope: Simple WordPress sites: 2-3 weeks, Custom business websites: 4-6 weeks, Complex web applications: 8-12 weeks. We'll provide a detailed timeline during our initial consultation."
        },
        {
            question: "Do you offer hosting and domain services?",
            answer: "Yes! We can help you set up hosting and register your domain. We also offer private cloud hosting solutions for businesses that need more control and security over their data."
        },
        {
            question: "Will my website be mobile-friendly?",
            answer: "Absolutely! All websites we build are fully responsive and optimized for mobile devices, tablets, and desktops. Mobile-first design is standard practice."
        },
        {
            question: "Can I update the website myself?",
            answer: "Yes. For WordPress sites, you'll have full access to an easy-to-use content management system. For custom sites, we can include a CMS or provide training on how to make updates. Ongoing support is also available."
        },
        {
            question: "Do you provide ongoing support and maintenance?",
            answer: "Yes, we offer maintenance packages that include security updates, backups, performance monitoring, and content updates. Plans start from R500/month depending on your needs."
        },
        {
            question: "What about SEO? Will my site rank on Google?",
            answer: "All websites include basic on-page SEO optimization. For comprehensive SEO services including keyword research, content strategy, and link building, we offer dedicated SEO packages starting from R3,500/month."
        },
        {
            question: "What's your payment structure?",
            answer: "For website projects: 50% deposit to start, 50% on completion. Monthly services (hosting, SEO, maintenance) are billed monthly in advance. Payment options include bank transfer and online payment."
        },
        {
            question: "Are you based in South Africa?",
            answer: "Yes, we're based in Centurion, Gauteng. We primarily work with South African businesses but also serve international clients. All communication is done remotely, with in-person meetings available for local clients if needed."
        }
    ]

    const toggleFAQ = (index) => {
        setOpenIndex(openIndex === index ? null : index)
    }

    return (
        <section className="section faq">
            <div className="section-inner">
                <div className="faq-header">
                    <div className="faq-header-content">
                        <h2 className="title title-h2">FAQ</h2>
                        <h3 className="subtitle subtitle-h3">Have Any Questions</h3>
                        <p className="description">
                            Here are answers to common questions about our services, pricing, and process. 
                            Don't see your question? <a href="/contact" className="text-link">Get in touch</a>.
                        </p>
                    </div>
                </div>

                <div className="faq-toggle-container">
                    <button 
                        className="faq-toggle-btn"
                        onClick={() => setShowFAQs(!showFAQs)}
                    >
                        <span>{showFAQs ? 'Hide' : 'View'} Q&A</span>
                        <i className={`fas fa-chevron-${showFAQs ? 'up' : 'down'}`}></i>
                    </button>
                </div>

                <div className={`faq-container ${showFAQs ? 'show' : ''}`}>
                    {faqs.map((faq, index) => (
                        <div 
                            key={index} 
                            className={`faq-item ${openIndex === index ? 'active' : ''} ${showFAQs ? 'visible' : ''}`}
                            style={{ 
                                transitionDelay: showFAQs ? `${index * 0.1}s` : `${(faqs.length - 1 - index) * 0.1}s`
                            }}
                        >
                            <button 
                                className="faq-question"
                                onClick={() => toggleFAQ(index)}
                                aria-expanded={openIndex === index}
                            >
                                <span>{faq.question}</span>
                                <i className={`fas fa-chevron-${openIndex === index ? 'up' : 'down'}`}></i>
                            </button>
                            <div className="faq-answer">
                                <p>{faq.answer}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}

export default FAQ
